<app-header></app-header>
<app-leftsidebar [activePath]="activePath"></app-leftsidebar>

<div class="aml-main">
  <div class="right-sec">
    <div class="aml-wrap">

      <div class="aml-head">
        <div class="aml-head-text">
          <h1>Available <span class="gold">maps</span></h1>
          <p>
            The worlds you've charted and the public atlas. Open any map to explore
            pins, run a session, or build lore in the wiki.
          </p>
        </div>
        <div class="aml-head-actions">
          <a class="btn btn-outline" routerLink="/map-packs">Map packs</a>
          <button class="btn btn-outline" (click)="openAzgaarMapGeneratorInfo()">Azgaar's generator</button>
          <button class="btn btn-theme" (click)="openWorldBuilder()" [disabled]="isMapUploadDisabled()">
            Create world
          </button>
        </div>
      </div>

      <div class="aml-toolbar">
        <div class="aml-tabs" role="tablist">
          <button role="tab" [attr.aria-selected]="selectedTab === 'all'" (click)="selectedTab = 'all'">
            All maps <span class="aml-count">{{ (maplistdata || []).length }}</span>
          </button>
          <button role="tab" [attr.aria-selected]="selectedTab === 'mine'" (click)="selectedTab = 'mine'">
            My maps <span class="aml-count">{{ myMaps.length }}</span>
          </button>
        </div>
        <div class="aml-view-toggle" role="group" aria-label="View" *ngIf="!isMobile">
          <button [attr.aria-pressed]="viewMode === 'large'" (click)="setViewMode('large')">Large</button>
          <button [attr.aria-pressed]="viewMode === 'small'" (click)="setViewMode('small')">Small</button>
        </div>
      </div>

      <div class="aml-grid" [class.is-small]="viewMode === 'small'">
        <article class="aml-card" *ngFor="let map of visibleMaps">
          <div class="aml-thumb" (click)="viewMap(map.map_id)">
            <img [src]="mapImg(map)" alt="" />
          </div>

          <div class="aml-body">
            <h3 class="aml-name" (click)="viewMap(map.map_id)">
              {{ map.map_name || 'Unnamed map' }}
              @switch (map.build?.state) {
                @case ('writing_lore') {
                  <span class="map-chip world-building" title="Your world's lore is being written; you can use the map meanwhile">
                    <span class="spinner-dot"></span> Writing lore… {{ buildPercent(map) }}%
                  </span>
                }
                @case ('failed') {
                  <span class="map-chip failed" (click)="showBuildError(map)" title="Why it stopped">
                    {{ map.build.can_retry ? "Couldn't finish" : "Couldn't process the map" }}
                  </span>
                }
                @default {
                  @if (isBuilding(map)) {
                    <span class="map-chip processing">
                      <span class="spinner-dot"></span> {{ map.build.label }}… {{ buildPercent(map) }}%
                    </span>
                  } @else if (map.build?.has_world) {
                    <span class="map-chip complete">World ready</span>
                  }
                }
              }
              @if (map.build?.terrain === 'painting') {
                <span class="map-chip processing" title="The map's terrain art is being painted; the map switches to it by itself">
                  <span class="spinner-dot"></span> Painting map art…
                </span>
              }
            </h3>
            <p class="aml-meta">
              by {{ mapCreator(map) }}
              <ng-container *ngIf="map.created_at"> · {{ map.created_at | date: 'dd MMM yyyy' }}</ng-container>
            </p>

            <div class="aml-stats">
              <div class="aml-stat"><span class="v">{{ map.active_characters || 0 }}</span><span class="k">Characters</span></div>
              <div class="aml-stat"><span class="v">{{ map.active_games || 0 }}</span><span class="k">Games</span></div>
              <div class="aml-stat"><span class="v">{{ (map.establishments || 0) + (map.city_establishments || 0) }}</span><span class="k">Establishments</span></div>
              <div class="aml-stat"><span class="v">{{ (map.adventures || 0) + (map.city_adventures || 0) }}</span><span class="k">Adventures</span></div>
            </div>

            <div class="aml-card-actions">
              <button class="btn btn-green" (click)="viewMap(map.map_id)">View</button>
              <button class="btn btn-outline" (click)="newGame(map)" [disabled]="isGameCreateDisabled()">New game</button>
              <button class="btn btn-outline" (click)="viewWiki(map)">Wiki</button>
              <button class="btn btn-outline" (click)="modifyMap(map)" *ngIf="user_id == map.user_id">Modify</button>
              <button class="btn btn-outline" (click)="retryBuild(map)" [disabled]="retrying[map.map_id]"
                *ngIf="map.build?.state === 'failed' && map.build?.can_retry && user_id == map.user_id">
                {{ retrying[map.map_id] ? 'Starting…' : 'Try again' }}
              </button>
            </div>
          </div>
        </article>

        <button class="aml-add" *ngIf="!shouldShowMapUploadLimitReached(); else uploadLimit"
          (click)="openWorldBuilder()" [disabled]="isMapUploadDisabled()">
          <span class="aml-add-plus">+</span>
          <span class="aml-add-label">Create a world</span>
          <span class="aml-add-sub">Upload a map or generate one with Azgaar's, then drop your first pins.</span>
        </button>
        <ng-template #uploadLimit>
          <div class="aml-limit">
            <span>You've reached your map upload limit. Subscribe to add more worlds.</span>
            <button class="btn btn-green" [routerLink]="['/subscription']" [queryParams]="{ isUser: true }">
              Subscribe
            </button>
          </div>
        </ng-template>

        <p class="aml-empty" *ngIf="visibleMaps.length === 0">
          {{ selectedTab === 'mine' ? "You haven't uploaded any maps yet." : 'No maps available.' }}
        </p>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
